import * as types from './types'

export default {
  SetAppWeb({ commit }, data) {
    commit(types.SETAPPWEB, data);
  },
  SetMatch({ commit }, data) {
    commit(types.SETMATCH, data);
  },
  SetGameId({ commit }, data) {
    commit(types.SETGAMEID, data);
  },
  SetMenuName({ commit }, data) {
    commit(types.SETMENUNAME, data);
  },
}



// WEBPACK FOOTER //
// ./src/store/actions.js